export default "__VITE_ASSET__X7pE7Esu__"